import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  form: FormGroup;
  errorMessage = '';
  showPassword = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router
  ) {
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  submit(): void {
    if (this.form.invalid) return;
    this.errorMessage = '';
    const { username, password } = this.form.value;
    void this.performLogin(username, password);
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  private async performLogin(username: string, password: string): Promise<void> {
    try {
      await firstValueFrom(this.auth.login(String(username), String(password)));
      this.router.navigateByUrl('/journal');
    } catch {
      this.errorMessage = 'Login fehlgeschlagen. Bitte erneut versuchen.';
    }
  }
}
